import { h, Component } from 'preact';
import { IoMdDownload } from 'react-icons/io';

export const Download = props => (
    <button name="download" onClick={ props.onClick } className="download controlBarButton vjs-control vjs-button">
        <IoMdDownload />
    </button>
);